/* 02 · HERO — sections/nhp-home-02-hero.liquid. Deferred. */
(function () {
  document.querySelectorAll('[data-nhp-hero]').forEach(function (hero) {
    var video = hero.querySelector('.nhp-hero__video');
    var pause = hero.querySelector('[data-nhp-hero-pause]');

    if (video && pause) {
      var setPaused = function (paused) {
        pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pause.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      };
      // Reduced motion: never autoplay (§10) — the poster frame stays until they press play.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.removeAttribute('autoplay');
        video.pause();
        setPaused(true);
      }
      pause.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          setPaused(false);
        } else {
          video.pause();
          setPaused(true);
        }
      });
    }

    var trailer = hero.querySelector('[data-nhp-trailer]');
    var open = hero.querySelector('[data-nhp-trailer-open]');
    if (trailer && open && trailer.showModal) {
      var tvid = trailer.querySelector('video');
      open.addEventListener('click', function () {
        trailer.showModal();
        if (tvid) tvid.play();
      });
      trailer.querySelector('[data-nhp-trailer-close]').addEventListener('click', function () { trailer.close(); });
      trailer.addEventListener('close', function () {
        if (tvid) tvid.pause();
        open.focus();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && trailer.open) trailer.close();
      });
    }
  });
})();
